import { render, staticRenderFns } from "./associationDetail.vue?vue&type=template&id=30e5e75f&"
import script from "./associationDetail.vue?vue&type=script&lang=js&"
export * from "./associationDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports